import { set_db } from '../http-worker/db-func';

const set_name = async (key: string, item_name: string, set_table_list: React.Dispatch<React.SetStateAction<any>>, no_db?: number): Promise<void> => {
  set_table_list((currentState: { [key: string]: any }): any => {
    currentState[key] = item_name;
    return { ...currentState };
  });

  item_name !== undefined && !no_db && set_db(key, item_name);
};

export default set_name;
